import { get, useFormContext } from 'react-hook-form';

export const useFormFieldError = (fieldName) => {
  const { formState } = useFormContext();
  const error = get(formState.errors, fieldName);

  return error;
};
